module.exports = __webpack_public_path__ + "img/bg_figure7.0e96bf44.png";